/*eslint no-console: 0*/

import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, FormattedHTMLMessage} from 'react-intl';
import config from '../../common/config';
import * as FeatureFlags from '../../common/util/FeatureFlags';
import urlMapping from '../app/URLMapping';

import LoadingButton from '../fw/LoadingButton.react';

import InvokeChannelJobMutation from './InvokeChannelJobMutation.react';
import types from '../../common/model-api/types';

import {wrapNotFound} from '../app/NotFoundHandler.react';
import EventTracker from '../app/EventTracker';
import ActivateChannelCachingMutation from './ActivateChannelCachingMutation.react';
import {showJobNotification} from '../app/notification';
import mutationError from '../channel-defs/mutationError';
import {CACHING_STATUS_NONE, CACHING_STATUS_CACHED} from "../../common/model-api/ChannelType";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import FlowSimpleList from '../flows/FlowSimpleList.react';

class ShoptetApplicationDetail extends React.Component {

	typeName = 'channels';

	static propTypes = {
		intl: PropTypes.object,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};
	static contextTypes = {
		router: PropTypes.object
	};

	constructor() {
		super();
	}

	filterFlows = (flow) => {
		const channel = this.props.user.organisation.channel;

		let selectedChannels = safeJSONparse(flow.selectedChannels);
		for (let key of Object.values(selectedChannels)) {
			if (key === channel.realId) {
				return true;
			}
		}
		return false;
	};

	render() {
		const data = this.props.user.organisation.channel;
		let type = types[this.typeName];

		let scenario1;
		let scenario2;

		if (this.props.user.scenario1.edges.length > 0) {
			scenario1 = this.props.user.scenario1.edges[0].node;
		}
		if (this.props.user.scenario2.edges.length > 0) {
			scenario2 = this.props.user.scenario2.edges[0].node;
		}

		return (
			<AppPanel breadcrumbParams={[
				{type, data},
				{type: types['organisations'], data: this.props.user.organisation}]
			} className="ChannelView" title={"AA"}>
				<h3><FormattedMessage defaultMessage="Activate caching" id="activateChannelCaching.title" /></h3>

				<div className="row">
					<div className="col-md-6">
						{scenario1 ?
							<div>
								<h4>{scenario1.title}</h4>
								<p>{scenario1.description}</p>
							</div>
						: null}
					</div>
					<div className="col-md-6">
						{scenario2 ?
							<div>
								<h4>{scenario2.title}</h4>
								<p>{scenario2.description}</p>
							</div>
						: null}
					</div>
				</div>
				<FlowSimpleList filter={this.filterFlows} organisation={this.props.user.organisation} />


			</AppPanel>
		);
	}
}

export default Relay.createContainer(wrapNotFound(injectIntl(ShoptetApplicationDetail), (props) => {
	return props.user.organisation && props.user.organisation.channel;
}), {
	initialVariables: {
		organisationId: '',
		channelId: '',
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				featureFlags,
				scenario1: publicScenarios(first: 1, urlFragment: "shoptet-to-flexibee") {
					edges {
						node {
							id,
							realId,
							name,
							title,
							description,
							createdAt,
							updatedAt,
						}
					}
				},
				scenario2: publicScenarios(first: 1, urlFragment: "connect-invoices-shoptet-with-flexibee-2") {
					edges {
						node {
							id,
							realId,
							name,
							title,
							description,
							createdAt,
							updatedAt,
						}
					}
				},
				organisation(id: $organisationId) {
					id,
					realId,
					name,
					featureFlags,
					channel(id: $channelId) {
						id,
						realId,
						organisation_id,
						type,
						description,
						name,
						metadata,
						channelDef {
							id,
							name,
							description,
							metadata,
							icon,
						},
					},
					${FlowSimpleList.getFragment('organisation')},
				}
			}
		`,
	},
});
